import { render, staticRenderFns } from "./boatFollow.vue?vue&type=template&id=43bd9c3a&"
import script from "./boatFollow.vue?vue&type=script&lang=js&"
export * from "./boatFollow.vue?vue&type=script&lang=js&"
import style0 from "./boatFollow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports